module.exports = __webpack_public_path__ + "static/img/tabs02.996f7650.png";